import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Field} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import z from "zod";
export const step4Schema = z.object({
  invoicePrefix: z.string().optional(),
  invoiceFirstNumber: z.number().min(1, {message: "Obligatoire"}),
});
export type Step4Form = z.infer<typeof step4Schema>;

type Props = {
  hookForm: UseFormReturn<Step4Form>;
  disabled: boolean;
};

export function Step4InvoiceNumber({hookForm, disabled}: Props) {
  const {t: translate} = useTranslation();
  const {watch} = hookForm;

  const invoicePrefix = watch("invoicePrefix");
  const invoiceFirstNumber = watch("invoiceFirstNumber");

  return (
    <>
      <p style={{marginBottom: "8px"}}>
        <strong>La numérotation de facture</strong>
      </p>
      <Field
        name="invoicePrefix"
        label={translate("myTourApp.platformUser.invoicePrefix")}
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field
        name="invoiceFirstNumber"
        type="number"
        label={"Numéro de la première facture"}
        hookForm={hookForm}
        disabled={disabled}
      />

      <div className={"alert alert-info"}>
        <p>
          <FontAwesomeIcon icon="circle-info" /> La première facture aura le numéro{" "}
          <strong>{getNextInvoiceNumber()}</strong>
        </p>
      </div>
    </>
  );

  function getNextInvoiceNumber() {
    let prefix = invoicePrefix ?? "";
    if (invoicePrefix) {
      prefix = invoicePrefix;
    }
    let num = 1;
    if (invoiceFirstNumber) {
      num = +invoiceFirstNumber;
    }
    return `${prefix}${num}`;
  }
}
